import { type HTMLAttributes } from "react";

export type CardProps = HTMLAttributes<HTMLDivElement>;

export function Card({ className = "", ...props }: CardProps) {
  return (
    <div
      className={
        "rounded-[var(--radius-lg)] bg-[var(--color-bg-card)] border border-[var(--color-border)] p-4 " +
        className
      }
      {...props}
    />
  );
}
